import apiClient from './Request'
import { baseUrls } from './../const'
import moment from 'moment'

export default {
  loginUser(user) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/user/login',
      data: user
    })
  },
  GetConfiguration() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/configurations/GetConfiguration'
    )
  },
  GetManufactures() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/manufacture/GetManufactures'
    )
  },
  GetManufactureById(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/manufacture/GetManufactureById?id=' + id
    )
  },
  AddorUpdateManufacture(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/manufacture/AddorUpdateManufacture',
      data: data
    })
  },
  GetProducts() {
    return apiClient.get(baseUrls['commonBaseUrl'] + '/product/GetProducts')
  },
  GetProductsById(userId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/product/GetProductsByUserId?userId=' +
        userId
    )
  },
  GetProductsByManufacturerId(manufacturerId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/product/GetProductsByManufacturerId?manufacturerId=' +
        manufacturerId
    )
  },
  GetProductDetailById(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/product/GetProductDetailById?id=' + id
    )
  },
  AddorUpdateProduct(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/product/AddorUpdateProduct',
      data: data
    })
  },
  GetProductThresholds() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/productthreshold/GetProductThresholds'
    )
  },
  GetProductThresholdsByProductId(productId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/productthreshold/GetProductThresholdsByProductId?productId=' +
        productId
    )
  },
  AddorUpdateProductThreshold(data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] +
        '/productthreshold/AddorUpdateProductThreshold',
      data: data
    })
  },
  CopyProductThreshold(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/productthreshold/CopyProductThreshold',
      data: data
    })
  },
  DeleteProductThreshold(id) {
    return apiClient.delete(
      baseUrls['commonBaseUrl'] +
        '/productthreshold/DeleteProductThreshold?productThresholdId=' +
        id
    )
  },
  GetPosition() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/productthreshold/GetPosition'
    )
  },
  GetPodCharacteristics() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/podcharacter/GetPodCharacteristics'
    )
  },
  AddorUpdatePodCharacteristics(data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] +
        '/podcharacter/AddorUpdatePodCharacteristics',
      data: data
    })
  },
  GetUserRoles(filterName) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/user/getusers?filterName=' + filterName
    )
  },
  GetRoles() {
    return apiClient.get(baseUrls['commonBaseUrl'] + '/role/getroles')
  },
  CreateUser(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/user/createuser',
      data: data
    })
  },
  UpdateUser(userId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/user/UpdateUser?userId=' + userId,
      data: data
    })
  },
  ResetPassword(userId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/user/ResetPassword?userId=' + userId,
      data: data
    })
  },
  UpdateUserRole(userId, roleId) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/role/UpdateUserRole?userId=' + userId,
      data: roleId
    })
  },
  GetRolePermission(roleId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/role/GetRolePermission?roleId=' + roleId
    )
  },
  SaveRolePermission(roleId, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['commonBaseUrl'] + '/role/saverolepermission?roleId=' + roleId,
      data: data
    })
  },
  DeleteRole(roleId) {
    return apiClient.delete(
      baseUrls['commonBaseUrl'] + '/role/DeleteRole?roleId=' + roleId
    )
  },
  GetMonitoring() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/production/GetMonitoring'
    )
  },
  GetTestReports(data) {
    let startDateTime = ''
    let endDateTime = ''
    if (data.date && data.date.length) {
      startDateTime = moment(data.date[0]).format('YYYY-MM-DD')
      endDateTime = moment(data.date[1]).format('YYYY-MM-DD')
    }
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/production/GetTestReports?podMac=' +
        data.podMac +
        '&testedBy=' +
        data.testedBy +
        '&hwVer=' +
        data.hwVer +
        '&fwVer=' +
        data.fwVer +
        '&startDateTime=' +
        startDateTime +
        '&endDateTime=' +
        endDateTime +
        '&result=' +
        data.result
    )
  },
  GetTestDetail(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/production/GetTestDetail?id=' + id
    )
  },
  SaveElectricalAcceptanceCriteria(data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] +
        '/production/SaveElectricalAcceptanceCriteria',
      data: data
    })
  },
  SaveFunctionalAcceptanceCriteria(data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] +
        '/production/SaveFunctionalAcceptanceCriteria',
      data: data
    })
  },
  GetFirmwares() {
    return apiClient.get(baseUrls['commonBaseUrl'] + '/firmware/getfirmwares')
  },
  MoveToProd(id) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/firmware/movetoprod?id=' + id
    })
  },
  MovetoStage(id) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/firmware/MovetoStage?id=' + id
    })
  },
  UploadFirmImgFile(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/firmware/uploadfirmimgfile',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  GetAcceptanceCriteria() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/production/GetAcptCriteria'
    )
  },
  GetManufacturerCodesByManufacturerId(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/Manufacture/GetManufacturerCodesByManufacturerId?manufacturerId=' +
        id
    )
  },
  CreateManufacturerCode(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/Manufacture/CreateManufacturerCode',
      data: data
    })
  },
  ApproveManufacturerCode(data) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/Manufacture/ApproveManufacturerCode',
      data: data
    })
  },
  ExpireManufacturerCode(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/Manufacture/ExpireManufacturerCode',
      data: data
    })
  }
}
